import React from "react";
import { Stack, Button, Grid } from "@mui/material";
import UserImage from "../../../components/UserImage";
import WheelExploreCard from "./WheelExploreCard";
import PropTypes from "prop-types";
import AmbassadorIcon from "../../../assets/icons/AmbassadorIcon";
import { colors } from "../../../utils";
import { TextView } from "../../../components";

const UserList = ({ user, wheels }) => {
  return (
    <Stack gap={2} sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, mb: 2 }}>
      {/* User Profile Section */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          <UserImage image={user?.profile_image} size={50} />
          <Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <TextView
                variant="Header3"
                style={{
                  fontWeight: 700,
                  color: colors.textBlue,
                }}
              >
                {user.first_name || user.last_name ? `${user.first_name} ${user.last_name}` : "Unkown User"}
              </TextView>
              {user.is_ambassador && <AmbassadorIcon size={20} />}
            </Stack>
            <span
              style={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "14px",
                color: colors.darkGrey,
              }}
            >
              <span style={{ fontWeight: 600 }}>{user.followers}</span> Followers
            </span>
          </Stack>
        </Stack>
        {/* <Stack direction="row" spacing={1}>
          <Button
            sx={{ textTransform: "none" }}
            variant="contained"
            color="primary"
          >
            Follow
          </Button>
          <Button sx={{ textTransform: "none" }} variant="outlined">
            Message
          </Button>
        </Stack> */}
      </Stack>

      {/* Wheels Grid */}
      <Grid container spacing={2}>
        {wheels?.map((wheel) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4} key={wheel.id}>
            <WheelExploreCard showUser={false} data={wheel} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default UserList;

UserList.propTypes = {
  user: PropTypes.object.isRequired,
  wheels: PropTypes.array.isRequired,
};
